import script from "./TextAreaSecondary.vue?vue&type=script&setup=true&lang=js"
export * from "./TextAreaSecondary.vue?vue&type=script&setup=true&lang=js"

import "./TextAreaSecondary.vue?vue&type=style&index=0&id=a813d3c8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a813d3c8"]])

export default __exports__